module.exports = __webpack_public_path__ + "static/semantic-icon-corner-grouped-89b2b061a64b1cef2ea91b5bc4000bf3.png";